import { HttpClient } from '@angular/common/http';
import * as ApiShipment from '../interfaces/api/shipment';
import { Injectable } from '@angular/core';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root',
})
export class ShipmentService extends BaseService {
  private urlShipment = `${this.apiUrl}/shipment`;

  constructor(private http: HttpClient) {
    super();
  }

  getListShipment(warehouseId: number, cartsIds: string) {
    return this.http.post<ApiShipment.ResponseGetListShipment>(`${this.urlShipment}/rate`, {
      id_mh_warehouse: warehouseId,
      carts: cartsIds,
    });
  }
}
